import React, {useState, useRef} from 'react';
import validateEmail from '../utils/validateEmail.js';
import FormText from '../components/FormText.js';
import post from '../utils/post.js';
import {Link} from 'react-router-dom';

export default function Forget() {
	const [username, setUsername] = useState('');
	const [usernameError, setUsernameError] = useState('');
	const [loading, setLoading] = useState(false);
	const [usrID, setUsrID] = useState(0);
	const [result, setResult] = useState('Zadejte email pro obnovu hesla');

	const usernameRef = useRef();

	const handleSubmit = (e) => {
		e.preventDefault();

		setUsernameError('');

		let localError = '';

		if (!username) {
			localError = 'Vyplňte email';
			setUsernameError(localError);
			usernameRef.current.focus();
		} else if (!validateEmail(username)) {
			localError = 'Neplatný email';
			setUsernameError(localError);
			usernameRef.current.focus();
		}

		if (!localError) {
			setLoading(true);

			post('forget', {username})
				.then((res) => {
					if (res.data > 0) {
						setUsrID(res.data);
					} else {
						setUsrID(0);
						setResult('Email není registrován');
					}

					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	return (
		<div className="login">
			{loading ? <div className="loading" /> : ''}

			<div className="login_shell">
				<div className="login_brand">
					<img className="login_logo" alt="" />
				</div>
				<div className="login_container auth-card auth-card--wide">
					<div className="login_container_in auth-card__body">
						<h1 className="auth-card__title">Zapomenuté heslo</h1>
						<p className="auth-card__text">Zadej registrovaný e-mail a pošleme ti odkaz pro nastavení nového hesla.</p>

						{usrID === 0 ? (
							<form method="POST" onSubmit={handleSubmit} className="auth-form">
								<div className="auth-form__field auth-form__field--full">
									<FormText type="text" label="Email" value={username} setValue={setUsername} ref={usernameRef} error={usernameError} />
								</div>
								<div className="auth-form__actions">
									<input type="submit" name="button_login" value="Odeslat" className="button auth-pill-button" disabled={loading} />
								</div>
								<div className="login_result auth-result">{result}</div>
							</form>
						) : (
							<div className="auth-message auth-message--success">Na zadaný e-mail byl zaslán odkaz na obnovení hesla.</div>
						)}

						<div className="auth-links auth-links--center">
							<Link to={'/'} key="lnk_login" className="lnk1 auth-link">
								Zpět na přihlášení
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
